import { useAppDispatch } from '../../../store/hooks';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import CustomAlert from '../../../components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import { InsertBanks } from '../../../store/NTX/Banks/banksSlice';
import { AddBankSchema } from '../../ValidationForm/validationSchema';

const Add = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const formik = useFormik({
    initialValues: {
      name: '',
      name2: '',
      code: '',
      note: '',
    },
    validationSchema: AddBankSchema(t),
    onSubmit: (values) => {
      dispatch(
        InsertBanks({
          name: values.name,
          name2: values.name2,
          code: values.code,
          note: values.note,
        })
      )
        .unwrap()
        .then((res: any) => {
          // debugger;
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            document.getElementById('closeModalForm')?.click();
            formik.resetForm();
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    },
  });
  const { values, errors, touched, handleChange } = formik;

  return (
    <Form onSubmit={formik.handleSubmit}>
      <div className="row">
        <div className="col-xl-4">
          <div className="form-group mb-3">
            <label className="form-label">{t('LocalName')}</label>
            <Form.Control
              className="form-control  "
              type="text"
              autoComplete="off"
              name="name2"
              onChange={handleChange}
              value={values.name2}
              isInvalid={!!(touched.name2 && errors.name2)}
            />
            <div className="text-danger small">{touched.name2 && errors.name2}</div>
          </div>
        </div>
        <div className="col-xl-4">
          <div className="form-group mb-3">
            <label className="form-label">{t('GlobalName')}</label>
            <Form.Control
              className="form-control  "
              type="text"
              autoComplete="off"
              name="name"
              onChange={handleChange}
              value={values.name}
              isInvalid={!!(touched.name && errors.name)}
            />
            <div className="text-danger small">{touched.name && errors.name}</div>
          </div>
        </div>
        <div className="col-xl-4">
          <div className="form-group mb-3">
            <label className="form-label">{t('Code')}</label>
            <Form.Control
              className="form-control"
              type="text"
              autoComplete="off"
              name="code"
              onChange={handleChange}
              value={values.code}
              isInvalid={!!(touched.code && errors.code)}
            />
            <div className="text-danger small">{touched.code && errors.code}</div>
          </div>
        </div>

        <div className="col-xl-12">
          <div className="form-group mb-3">
            <label className="form-label">{t('Note')}</label>
            <Form.Control
              className="form-control"
              as="textarea"
              rows={1}
              // type="text"
              autoComplete="off"
              name="note"
              onChange={handleChange}
              value={values.note}
            />
          </div>
        </div>
      </div>

      <div className="text-center">
        <div className="d-flex justify-content-between gap-2">
          <button
            disabled={formik.isSubmitting}
            type="submit"
            className="btn btn-lg btn-theme mb-1 w-100">
            {formik.isSubmitting ? (
              <div className="spinner-border spinner-border-sm me-2"></div>
            ) : (
              <i className="fas fa-save fa-lg fa-fw me-2"></i>
            )}
            {t('Add')}
          </button>
          <button
            type="button"
            className="btn btn-lg  btn-default mb-1 w-100"
            data-bs-dismiss="modal"
            id="closeModalJob">
            <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
          </button>
        </div>
      </div>
    </Form>
  );
};

export default Add;
